import { render, staticRenderFns } from "./teaTestDeclareManage.vue?vue&type=template&id=054eaa03"
import script from "./teaTestDeclareManage.vue?vue&type=script&lang=js"
export * from "./teaTestDeclareManage.vue?vue&type=script&lang=js"
import style0 from "./teaTestDeclareManage.vue?vue&type=style&index=0&id=054eaa03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports